import {DateTime} from 'luxon';
import moment from 'moment-timezone';

/**
 * Converts a UTC date string into a timezone-aware date string
 * @param {*} dateStr the initial date string, in UTC
 * @param {*} timeZone the timezone to transform into
 * @returns string
 */

// biome-ignore lint/suspicious/noExplicitAny: allow any
export const convertUTCDateToTzAwareDate = (dateStr: any, timeZone: any = ''): any => {
  const date = moment.utc(dateStr);
  if (!timeZone) return date.toString();
  return date.tz(timeZone).toString();
};

/**
 * Formats a Luxon DateTime object for backend use
 * @param dateTime - A Luxon DateTime object
 * @returns A formatted date string in the format '2025-12-31T23:59:59'
 */
export const formatDateForBackend = (dateTime: DateTime): string => {
  if (!dateTime.isValid) {
    throw new Error('Invalid DateTime object provided to formatDateForBackend');
  }
  return dateTime.toFormat("yyyy-MM-dd'T'HH:mm:ss");
};

/**
 * Merges a JavaScript Date object with a time string to create a Luxon DateTime object
 * @param date - A JavaScript Date object
 * @param time - A time string in the format 'h:mm a' (e.g., '11:59 PM')
 * @returns A Luxon DateTime object with the merged date and time
 */
export const mergeDateAndTime = (date: Date, time: string): DateTime => {
  const timeOnly = DateTime.fromFormat(time, 'h:mm a');
  if (!timeOnly.isValid) {
    throw new Error(`Invalid time format: ${time}`);
  }
  return DateTime.fromJSDate(date).set({
    hour: timeOnly.hour,
    minute: timeOnly.minute,
  });
};

/**
 * Formats a Luxon DateTime object for display
 * @param dateTime - A Luxon DateTime object
 * @returns A formatted date string in the format 'Fri Dec 31, 11:59 PM MDT'
 */
export const formatDateForDisplay = (dateTime: DateTime): string => {
  if (!dateTime.isValid) {
    throw new Error('Invalid DateTime object provided to formatDateForDisplay');
  }
  return dateTime.toFormat('ccc MMM d, h:mm a ZZZZ');
};
